module.exports = __webpack_public_path__ + "img/6_139.cfbe3d7d.png";